import { API, PublicAccessApprovalMode } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type updateSpacePublicAccessInput = {
  spaceId: number;
  downloadsRestricted?: boolean;
  downloadsRestrictedApproveMode?: PublicAccessApprovalMode;
};

const [useUpdateSpacePublicAccess, updateSpacePublicAccess] = createAsyncAction(
  "spaces/updateSpacePublicAccess",
  async ({
    spaceId,
    downloadsRestricted,
    downloadsRestrictedApproveMode,
  }: updateSpacePublicAccessInput) => {
    const data = {
      downloads_restricted: downloadsRestricted,
      downloads_restricted_approve_mode: downloadsRestrictedApproveMode,
    };
    Object.keys(data).forEach(key => data[key] === undefined && delete data[key]);
    const res = await API.call<{ space: number }>({
      endpoint: `spaces/${spaceId}`,
      method: "PUT",
      data,
    });
    return { ...res, result: res.result.space };
  }
);

export default useUpdateSpacePublicAccess;
export { updateSpacePublicAccess };
